export default [{
    name: 'AWB',
    value: 's_mawb'
}, {
    name: 'Pieces',
    value: ''
}, {
    name: 'Weight',
    value: 'f_weight'
}, {
    name: 'Volume',
    value: 's_volume'
}, {
    name: 'Commodity',
    value: 's_commodity'
}, {
    name: 'Routing',
    value: ''
}, {
    name: 'SHC',
    value: 's_special_handling_code'
}, {
    name: 'Consignee',
    value: 's_consignee'
}];